'use client'

import '@/global/plugins/observability/observability.setup'

export const ObservabilityInit = () => {
  return null
}
